/**
 * The possible API actions enable via bianka client API.
 */
export const ACTIONS = {
    ACTIVITY: 'activity',
    BUSINESS: 'business'
};
